import * as THREE from 'three/build/three.module';
import { PrimitiveType } from './J3TypeList';
import { J3MaterialMaker } from './J3MaterialMaker';

export class J3PrimitiveMaker extends EventTarget {
    parent:THREE.Object3D;

    constructor() {
        super();
        //this.MakePrimitive(parent, param);
    }

    MakePrimitive(parent:THREE.Object3D, param){
        this.parent = parent;
        const materialMaker = new J3MaterialMaker();
        materialMaker.addEventListener('MaterialSet', (evt)=>{this.SetGeometry(evt, param)});
        materialMaker.MakeMaterial(param.material.type, param.material.addTexture, param.material.image, param.material.property);
    }

    SetGeometry(evt, param){
        console.log('MakePrimitive', param.material.type, param.material.property);
        const material:THREE.Material = evt.detail.material;
        const g = param.geometry;
        const type:PrimitiveType = g.type;
        let geometry;
        switch (type){
            case 'cube':
                geometry = new THREE.BoxGeometry(g.width, g.height, g.depth, g.widthSeg, g.heightSeg, g.depthSeg)
                break;
            case 'sphere':
                geometry = new THREE.SphereGeometry(g.radius, g.widthSeg, g.heightSeg);
                break;
            case 'plane':
                geometry = new THREE.PlaneGeometry(g.width, g.height, g.widthSeg, g.heightSeg);
                break;
            default:
                console.log('*** geometry', type, 'not created ***');
                geometry = null;
                break;
        }

        //Meshの作成
        if (geometry != null){
            const mesh = new THREE.Mesh(geometry, material);
            const p = param.position;
            mesh.position.set(p[0],p[1],p[2]);
            const r = param.rotation;
            const f = Math.PI/180;
            mesh.rotation.set(f*r[0],f*r[1],f*r[2]);
            const s = param.scale;
            mesh.scale.set(s[0],s[1],s[2]);
            this.parent.add(mesh);   //ポジション・ローテーションを有効にするために最後に親オブジェクトにAddする
        }else{
            console.log('*** Mesh not created ***', type);
        }
        
    }
}